module.exports = __webpack_public_path__ + "static/pic02-9abd6da6f8aa12d55c0f36e9b6b56754.jpg";